/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../../extendIcon';

const Deha14 = props => (
  <svg width="1em" height="1em" viewBox="0 0 61 126" {...props}>
    <g
      transform="translate(0.000000,126.000000) scale(0.100000,-0.100000)"
      stroke="none"
    >
      <path d="M137 1248 c-9 -7 -21 -28 -26 -45 l-10 -33 205 0 c199 0 204 1 204 20 0 12 -11 32 -25 45 -23 24 -28 25 -178 25 -107 0 -158 -4 -170 -12z" />
      <path d="M61 1071 c-52 -134 -56 -164 -56 -451 0 -287 2 -304 63 -448 l27 -62 209 2 209 3 29 52 c52 93 59 136 63 403 4 306 -2 359 -51 483 l-38 97 -212 0 -211 0 -32 -79z m435 -107 c69 -51 69 -51 72 -317 4 -277 -2 -309 -66 -352 -35 -24 -43 -25 -195 -25 -176 0 -199 6 -239 62 -22 32 -23 40 -26 278 -3 239 -2 246 20 290 17 33 35 51 68 68 42 21 55 23 192 20 130 -3 150 -5 174 -24z" />
      <path d="M227 432 c-21 -23 -22 -56 -1 -76 11 -12 35 -16 84 -16 62 0 71 3 85 24 11 17 13 30 6 48 -12 32 -28 38 -100 38 -43 0 -62 -5 -74 -18z" />
      <path d="M104 74 c3 -9 6 -20 6 -25 0 -5 9 -18 20 -29 18 -18 33 -20 174 -20 169 0 188 6 202 63 l6 27 -207 0 c-185 0 -206 -2 -201 -16z" />
    </g>
  </svg>
);
export default extendIcon(Deha14);
